/* eslint-disable no-shadow */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import Table from "../../../../components/common/new/Table/Table";
import {
  EXAM_APPLIED_MEMBER_SEAECH_TABLE_COL,
  EXAM_RESULT_MEMBER_SEAECH_TABLE_COL_OTHER_THAN_INTERMEDIATE,
} from "../../../../contants/table/memberSearch";
import styles from "./styles";
import Typography from "../../../../components/common/new/Typography/Typography";
import { PERMISSIONS } from "../../../../contants";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
  large: {
    maxWidth: "16rem",
  },
};
// 👇 helper function (TableResultMembers ke upar ya andar)
const getStatusUI = (status) => {
  if (status === "CLEARED") {
    return { text: "Cleared", color: "green", fontWeight: 800 };
  }

  if (status === "NOT_CLEARED") {
    return { text: "Not Cleared", color: "red", fontWeight: 800 };
  }

  if (status === "APPLIED") {
    return { text: "Not Appeared", color: "blue", fontWeight: 800 };
  }

  return { text: "-", color: "inherit", fontWeight: 800 };
};

function TableResultMembers({
  searchData,
  onSelectMemberForTransfer,
  onMemberToggle,
  onMemberStatusToggleForHelpDesk,
  onSelectMember,
  hasPermission,
  showStatusColumn,
  onEdit,
  onToggleHDC,
  isChapterSi,
  isHelpDesk,
  isAreaSi,
  isZoneSi,
  isHelpDeskAdmin,
  onMemberReactivateToggle,
}) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let columns =
    queryParams?.get("examLevel") === "ENTRANCE"
      ? EXAM_APPLIED_MEMBER_SEAECH_TABLE_COL
      : EXAM_RESULT_MEMBER_SEAECH_TABLE_COL_OTHER_THAN_INTERMEDIATE;

  if (hasPermission(PERMISSIONS.DEACTIVATE_EXAMINATION_APPLIED_MEMBER)) {
    columns = [...columns];
  }

  const getRows = ({ searchData }) =>
    searchData?.map((memberInfo) => {
      const person = memberInfo;
      const isMember = memberInfo?.attendeeType === "Member";
      const info = isMember ? memberInfo.member : memberInfo.friend;

      return (
        <TableRow>
          <TableCell style={tabelCellWidth.medium}>
            <Typography style={styles.typoghrphyStyle}>
              {isMember ? info?.memberId : info?.friendId}
            </Typography>
          </TableCell>
          {queryParams?.get("examLevel") === "ENTRANCE" && (
            <TableCell style={tabelCellWidth.small}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {memberInfo?.attendeeType || "-"}{" "}
                </Typography>
              </div>
            </TableCell>
          )}
          <TableCell style={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {person?.rollNumber || "-"}
              </Typography>
            </div>
          </TableCell>
          <TableCell style={tabelCellWidth.medium}>
            <Typography style={styles.typoghrphyStyle}>
              {person?.memberName || "N/A"}
            </Typography>
          </TableCell>
          {/* <TableCell style={tabelCellWidth.medium}>
            <Typography style={styles.typoghrphyStyle}>
              {info?.mobileNumber}
            </Typography>
          </TableCell> */}
          <TableCell style={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {info?.divisionName || "-"}
              </Typography>
            </div>
          </TableCell>
          <TableCell style={tabelCellWidth.large}>
            <div style={styles.tableBoxNoOverFlow}>
              <Typography style={styles.typoghrphyStyle}>
                {[
                  info?.areaName,
                  info?.clusterName,
                  info?.zoneName,
                  info?.regionName,
                  info?.chapterName,
                  info?.districtName,
                  info?.blockName,
                ]
                  .filter(Boolean) // remove undefined/null
                  .join("/ ") || "-"}
              </Typography>
            </div>
          </TableCell>
          <TableCell style={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              {(() => {
                const status = getStatusUI(person?.applicationStatus);

                return (
                  <Typography
                    style={{
                      ...styles.typoghrphyStyle,
                      fontWeight: status.fontWeight,
                      color: status.color,
                    }}
                  >
                    {status.text}
                  </Typography>
                );
              })()}
            </div>
          </TableCell>
        </TableRow>
      );
    });
  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          onSelectMemberForTransfer,
          onSelectMember,
          hasPermission,
          onMemberToggle,
          onMemberStatusToggleForHelpDesk,
          showStatusColumn,
          isChapterSi,
          isHelpDesk,
          isAreaSi,
          isZoneSi,
          onEdit,
          onToggleHDC,
          isHelpDeskAdmin,
          onMemberReactivateToggle,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          // textAlign: "left",
        }}
      />
    </div>
  );
}

export default TableResultMembers;
